import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { mapActions } from "vuex";
export default {
  data: function data() {
    return {
      loading: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["database", "get"])), {}, {
    nextHouse: function nextHouse() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var DB, dbForm, searchForm, res, list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _context.n = 1;
              return _this.database({
                user: true
              });
            case 1:
              DB = _context.v;
              dbForm = {};
              searchForm = {
                type: 2,
                // 待审核
                pn: 1,
                ps: 1,
                new: "",
                cityId: "",
                districtId: ""
              };
              if (_this.$route.query.from == "house_audit_edit") {
                if (DB.value() && DB.value().$page["/house/audit"] && DB.value().$page["/house/audit"].searchForm) {
                  dbForm = DB.value().$page["/house/audit"].searchForm;
                }
                // console.log(dbForm);
                if (dbForm) {
                  searchForm.new = dbForm.new; // 1:New 2:Renew
                  searchForm.cityId = dbForm.cityId;
                  searchForm.districtId = dbForm.districtId;
                }
              } else if (_this.$route.query.from == "quarter_audit_edit") {
                searchForm.userTypeStatus = 3;
                searchForm.brandVip = 1;
              } else if (_this.$route.query.from == "brand_audit_edit") {
                searchForm.brandStatus = 3;
                searchForm.isBrand = 1;
              }
              _context.n = 2;
              return _this.$api.getHouseList(searchForm);
            case 2:
              res = _context.v;
              list = res.data.list;
              if (list.length > 0) {
                if (list[0] && list[0].id) {
                  console.log(list[0].id);
                  _this.$router.push({
                    path: "/house/update",
                    query: {
                      id: list[0].id,
                      userId: list[0].userInfo.id,
                      from: _this.$route.query.from
                    }
                  });
                }
              } else {
                _this.$message.success("该筛选范围内房源已清空~");
              }
              _this.loading = false;
              // console.log(res.data.list);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  })
};